module.exports = __webpack_public_path__ + "static/media/picto-friends.0206dc23.svg";